import React from 'react';

import StatusBox from 'components/StatusBox';

import './styles.css';

const SENT = 'Sent';
const UNSENT = 'Unsent';
const CANCELLED = 'Cancelled';
const COMPLETE = 'Complete';
const SIGNED_MANUALLY = 'Signed manually';

/*
 *Colors are defined in this trello card:
 *https://trello.com/c/y2Tid1m5/3182-introduce-agreement-status
*/

const AGREEMENT_STATUS_TO_COLOR = {
  [SENT]: '#ffd655',
  [UNSENT]: '#ff9420',
  [CANCELLED]: '#b5beca',
  [COMPLETE]: '#49cd35',
  [SIGNED_MANUALLY]: '#49cd35'
};

const AgreementStatus = ({status}) => (
  <StatusBox status={status} color={AGREEMENT_STATUS_TO_COLOR[status]} />
);

export default AgreementStatus;
